import React, { useState } from 'react';

const rights = [
  {
    id: 'innsyn',
    title: 'Rett til innsyn',
    article: 'Art. 15',
    desc: 'Du har rett til å få bekreftet om vi behandler personopplysninger om deg, og i så fall få tilgang til disse opplysningene samt informasjon om behandlingen.',
    action: 'Send forespørsel til personvern@nordpass.no'
  },
  {
    id: 'retting',
    title: 'Rett til retting',
    article: 'Art. 16',
    desc: 'Du har rett til å få uriktige personopplysninger om deg rettet uten ugrunnet opphold. Du kan oppdatere de fleste opplysninger direkte i din brukerprofil.',
    action: 'Oppdater i Min Konto eller kontakt oss'
  },
  {
    id: 'sletting',
    title: 'Rett til sletting',
    article: 'Art. 17',
    desc: 'Du har rett til å få dine personopplysninger slettet («retten til å bli glemt») under visse omstendigheter, for eksempel når opplysningene ikke lenger er nødvendige.',
    action: 'Send slettingsforespørsel til personvern@nordpass.no'
  },
  {
    id: 'portabilitet',
    title: 'Rett til dataportabilitet',
    article: 'Art. 20',
    desc: 'Du har rett til å motta dine personopplysninger i et strukturert, alminnelig brukt og maskinlesbart format, og til å overføre disse til en annen behandlingsansvarlig.',
    action: 'Last ned dine data fra Min Konto'
  },
  {
    id: 'innsigelse',
    title: 'Rett til innsigelse',
    article: 'Art. 21',
    desc: 'Du har rett til å protestere mot behandling av dine personopplysninger som er basert på berettiget interesse, inkludert profilering og direkte markedsføring.',
    action: 'Kontakt personvern@nordpass.no'
  },
  {
    id: 'begrensning',
    title: 'Rett til begrensning',
    article: 'Art. 18',
    desc: 'Du har rett til å kreve at behandlingen av dine personopplysninger begrenses under visse omstendigheter, for eksempel mens en innsigelse behandles.',
    action: 'Send forespørsel til personvern@nordpass.no'
  },
  {
    id: 'samtykke',
    title: 'Trekke tilbake samtykke',
    article: 'Art. 7(3)',
    desc: 'Der behandlingen er basert på samtykke, har du rett til å trekke tilbake samtykket ditt når som helst. Tilbaketrekkingen påvirker ikke lovligheten av behandling som fant sted før tilbaketrekkingen.',
    action: 'Administrer samtykke i Min Konto'
  },
  {
    id: 'klage',
    title: 'Rett til å klage',
    article: 'Art. 77',
    desc: 'Du har rett til å klage til Datatilsynet (datatilsynet.no) dersom du mener at behandlingen av dine personopplysninger er i strid med GDPR.',
    action: 'Datatilsynet: postkasse@datatilsynet.no'
  },
];

const UserRightsSection = () => {
  const [expanded, setExpanded] = useState(null);

  return (
    <section id="rettigheter" style={{ marginBottom: '80px' }}>
      {/* Color-blocked header */}
      <div
        style={{
          background: 'linear-gradient(135deg, #F97316 0%, #EA580C 100%)',
          padding: '40px',
          marginBottom: '40px',
          position: 'relative',
          clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 20px), calc(100% - 20px) 100%, 0 100%)'
        }}
      >
        <div
          style={{
            fontFamily: 'Impact, sans-serif',
            fontSize: 'clamp(4rem, 10vw, 8rem)',
            fontWeight: 900,
            color: 'rgba(0,0,0,0.1)',
            lineHeight: 1,
            position: 'absolute',
            top: '0',
            right: '20px',
            userSelect: 'none',
            letterSpacing: '-0.04em'
          }}
        >
          05
        </div>
        <div
          style={{
            fontFamily: 'JetBrains Mono, monospace',
            fontSize: '0.6875rem',
            color: 'rgba(0,0,0,0.5)',
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            marginBottom: '8px'
          }}
        >
          § 5 — DINE RETTIGHETER
        </div>
        <h2
          style={{
            fontFamily: 'Impact, sans-serif',
            fontSize: 'clamp(1.75rem, 4vw, 3rem)',
            fontWeight: 900,
            color: '#050A12',
            textTransform: 'uppercase',
            letterSpacing: '-0.02em',
            lineHeight: 1
          }}
        >
          Dine GDPR-rettigheter
        </h2>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {rights?.map((right, i) => (
          <div
            key={right?.id}
            style={{
              background: expanded === right?.id ? 'rgba(59,111,212,0.06)' : 'rgba(255,255,255,0.02)',
              border: expanded === right?.id ? '1px solid rgba(59,111,212,0.25)' : '1px solid rgba(255,255,255,0.06)',
              transition: 'all 200ms ease'
            }}
          >
            <button
              onClick={() => setExpanded(expanded === right?.id ? null : right?.id)}
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                padding: '20px 24px',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                textAlign: 'left'
              }}
            >
              <span
                style={{
                  fontFamily: 'JetBrains Mono, monospace',
                  fontSize: '0.625rem',
                  color: '#F97316',
                  background: 'rgba(249,115,22,0.1)',
                  border: '1px solid rgba(249,115,22,0.2)',
                  padding: '3px 8px',
                  letterSpacing: '0.08em',
                  flexShrink: 0
                }}
              >
                {right?.article}
              </span>
              <span
                style={{
                  fontFamily: 'Syne, sans-serif',
                  fontSize: '1rem',
                  fontWeight: 700,
                  color: '#EEF0F2',
                  flex: 1
                }}
              >
                {right?.title}
              </span>
              <span
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '1.25rem',
                  color: 'rgba(138,149,163,0.5)',
                  transform: expanded === right?.id ? 'rotate(45deg)' : 'rotate(0deg)',
                  transition: 'transform 200ms ease',
                  flexShrink: 0
                }}
              >
                +
              </span>
            </button>

            {expanded === right?.id && (
              <div style={{ padding: '0 24px 24px', paddingLeft: '80px' }}>
                <p
                  style={{
                    fontFamily: 'Georgia, serif',
                    fontSize: '0.9375rem',
                    color: 'rgba(238,240,242,0.7)',
                    lineHeight: 1.7,
                    marginBottom: '14px'
                  }}
                >
                  {right?.desc}
                </p>
                <div
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    background: 'rgba(59,111,212,0.1)',
                    border: '1px solid rgba(59,111,212,0.2)',
                    padding: '8px 14px'
                  }}
                >
                  <div style={{ width: '6px', height: '6px', background: '#3B6FD4', borderRadius: '50%', flexShrink: 0 }} />
                  <span
                    style={{
                      fontFamily: 'Inter, sans-serif',
                      fontSize: '0.8125rem',
                      color: '#3B6FD4'
                    }}
                  >
                    {right?.action}
                  </span>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default UserRightsSection;
